// Whitelist for the Cut Grade noise-filter toggle (Task 1669). Junk values
// seen in raw data: "Princess-Cut", "8x", "N/A", "NONE". Keep in sync with
// the backend's cut-grade whitelist once BE Task 1666/B2 lands.
export const CUT_GRADE_WHITELIST = [
  "Ideal",
  "Excellent",
  "Very Good",
  "Good",
  "Fair",
];

export const isValidCutGrade = (label) =>
  CUT_GRADE_WHITELIST.some(
    (grade) => grade.toLowerCase() === String(label ?? "").trim().toLowerCase()
  );
